
import { Component, Vue } from "vue-property-decorator";

@Component
/**
 * @desc Home component script.
 * @extends {Vue}
 */
export default class LiinkHome extends Vue {}
